module.exports = require('./helpers/bundle-url').getBundleURL('9ndqt') + "../img/" + require('./helpers/bundle-manifest').resolve("bapBQ");